import {Component, ElementRef, Inject, OnInit, SecurityContext, ViewChild, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
    selector: 'wfdss-madcap-web-help-popup',
    templateUrl: './madcap-web-help-popup.component.html',
    styleUrls: ['./madcap-web-help-popup.component.scss'],
    standalone: false
})
export class MadcapWebHelpPopupComponent implements OnInit {
    safeURL: SafeResourceUrl;
    // innerHTML: string;
    @ViewChild('popUpContainer') popUpContainer: ElementRef;

    constructor(
        public dialogRef: MatDialogRef<MadcapWebHelpPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private sanitizer: DomSanitizer
    ) {
        this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
        // this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl('http://localhost:4200/');
    }

    ngOnInit() {
        // this.innerHTML = this.data.innerHTML;
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
